import React from "react";
import { useDragLayer } from "react-dnd";
import { DND_ITEM_TYPES } from "./supplyTableRow";
import DragPreviewCard from "./DragPreviewCard";

/**
 * SupplyTableRow の並び替えドラッグ用カスタムプレビュー。
 * レイアウト/フォントは <DragPreviewCard /> と共通 (FreeProduct 側と完全一致)。
 *
 * 使い方: DndProvider 配下のどこか 1 箇所に <SupplyTableRowDragPreview /> を mount するだけ。
 */
const SupplyTableRowDragPreview = () => {
  const { isDragging, item, type, currentOffset } = useDragLayer((m) => ({
    isDragging: m.isDragging(),
    item: m.getItem(),
    type: m.getItemType(),
    currentOffset: m.getClientOffset(),
  }));

  if (!isDragging) return null;
  if (type !== DND_ITEM_TYPES.PRODUCT_ROW) return null;
  if (!currentOffset) return null;

  const product = item.product || {};
  const originName = product.originName ?? product.origin ?? "";
  const rankName = product.rankName ?? product.rank ?? "";
  const productClassName = product.productClassName ?? product.productClass ?? "";
  const packingName = product.packingName ?? product.packing ?? "";
  const weightUnitName = product.weightUnitName ?? product.weightUnit ?? "";

  const computedSpecs = [originName, rankName, productClassName, packingName]
    .filter(Boolean)
    .join(" / ");
  // 個別 field が無い form の場合は事前計算済みの displaySize にフォールバック
  const specs = computedSpecs || product.displaySize || "";

  const weightText = product.weight ? `${product.weight}${weightUnitName}` : "";
  // displaySize には weight も含まれるため、フォールバック時は extra 行を出さない
  const extra = computedSpecs
    ? [weightText, product.otherSpec].filter(Boolean).join(" ・ ")
    : "";

  return (
    <DragPreviewCard
      currentOffset={currentOffset}
      productName={product.productName}
      specs={specs}
      extra={extra}
    />
  );
};

export default SupplyTableRowDragPreview;
